import { isEmpty, isEqual, isString } from 'lodash';
import { API } from '@shared/types/api';
import { EditableField, Field } from './Field';

export class TagField implements EditableField {
  readonly fieldType = 'TagField';
  readonly tagIds: string[];
  readonly componentId: string;
  readonly tagOptions: API.TagComponentOption[];
  readonly multiselect: boolean;
  readonly addAdditionalValues: boolean;

  constructor(
    tagIds: string[],
    componentId: string,
    tagOptions: API.TagComponentOption[],
    multiselect: boolean,
    addAdditionalValues: boolean,
  ) {
    this.tagIds = tagIds;
    this.componentId = componentId;
    this.tagOptions = tagOptions;
    this.multiselect = multiselect;
    this.addAdditionalValues = addAdditionalValues;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return (
      field instanceof TagField &&
      this.componentId === field.componentId &&
      isEqual(this.tagIds, field.tagIds)
    );
  }

  toFieldJson() {
    return this.tagIds;
  }

  get isEmpty() {
    return isEmpty(this.tagIds);
  }

  static fromFieldJson(
    jsonBlob: any,
    componentId: string,
    tagOptions: API.TagComponentOption[],
    multiselect: boolean,
    addAdditionalValues: boolean,
  ) {
    if (Array.isArray(jsonBlob) && jsonBlob.every(isString)) {
      return new TagField(jsonBlob, componentId, tagOptions, multiselect, addAdditionalValues);
    } else {
      return null;
    }
  }
}
